import { render } from "./dashBoardTable.vue?vue&type=template&id=15359b3a&scoped=true&ts=true"
import script from "./dashBoardTable.vue?vue&type=script&lang=ts"
export * from "./dashBoardTable.vue?vue&type=script&lang=ts"

import "./dashBoardTable.vue?vue&type=style&index=0&id=15359b3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15359b3a"]])

export default __exports__